import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import SearchBox from 'components/Molecules/SearchBox';
import DropdownMenu from 'components/Molecules/DropdownMenu';
import Typographys from 'components/Atoms/Typography';
import DatePicker from 'components/Atoms/Datepicker';
import Button from 'components/Atoms/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconWithTitle from 'components/Atoms/IconWithTitle';
import UserTimeline from 'components/Organisms/Timeline/UserTimeline';
import { timelineStyle } from '../style';

const TotalTimeline = ({
  totalTimelineTitle,
  handleTotalTimelineSearch,
  totalTimelineFilter,
  totalTimeline,
  totalTimelineStartDateChange,
  totalTimelineEndDateChange,
  totalTimelineOnFetch,
}) => {
  const [showTimeLine, setShowTimeLine] = useState(false);
  const handleFetch = () => {
    totalTimelineOnFetch();
    setShowTimeLine(true);
  };

  return (
    <Box sx={timelineStyle.timelineWrapper}>
      {showTimeLine ? (
        <>
          <Box sx={timelineStyle.timelineHeader}>
            <IconWithTitle
              iconElement={<ArrowBackIcon fontSize="inherit" />}
              iconColor="neutral.600"
              iconFontSize="2rem"
              title={totalTimelineTitle}
              titleColor="neutral.600"
              titleVariant="body1"
              onClick={() => {
                setShowTimeLine(false);
              }}
            />
            <Box display="flex" alignItems="center">
              <Box mr={1} maxWidth="18.75rem">
                <SearchBox
                  size="small"
                  placeholder="Search..."
                  id="totalTimelineSearch"
                  name="totalTimelineSearch"
                  handleChange={handleTotalTimelineSearch}
                />
              </Box>
              <DropdownMenu btnLabel="Filter" color="info" menuLists={totalTimelineFilter} />
            </Box>
          </Box>

          <Box mt={3}>
            <UserTimeline timeLineLists={totalTimeline} />
          </Box>
        </>
      ) : (
        <>
          <Box mb={1.75}>
            <Typographys variant="body2" color="neutral.600">
              Select the duration of timeline
            </Typographys>
          </Box>
          <Grid container columnGap={8.75} flexWrap={{ lg: 'noWrap' }}>
            <Grid item maxWidth="34.375rem" mb={2}>
              <DatePicker
                name="startDate"
                id="startDate"
                label="Start Date"
                autoComplete="Start Date"
                onChange={totalTimelineStartDateChange}
                required
                fullWidth
                autoFocus
              />
            </Grid>

            <Grid item maxWidth="34.375rem" mb={2}>
              <DatePicker
                name="endDate"
                id="endDate"
                label="End Date"
                autoComplete="endDate"
                onChange={totalTimelineEndDateChange}
                required
                fullWidth
                autoFocus
              />
            </Grid>
          </Grid>
          <Button variant="contained" size="medium" onClick={handleFetch}>
            Fetch
          </Button>
        </>
      )}
    </Box>
  );
};
TotalTimeline.defaultProps = {
  totalTimeline: [
    {
      date: '5th Dec 2022',
      time: '3:50:51 IST',
      title: 'Total Timeline',
      desc: 'Aachman kabir(1001)',
      note: '',
    },
    {
      date: '5th Dec 2022',
      time: '3:50:51 IST',
      title: 'Total Timeline',
      desc: 'Aachman kabir(1001)',
      note: '',
    },
    {
      date: '5th Dec 2022',
      time: '3:50:51 IST',
      title: 'Total Timeline',
      desc: 'Aachman kabir(1001)',
      note: '',
    },
    {
      date: '5th Dec 2022',
      time: '3:50:51 IST',
      title: 'Total Timeline',
      desc: 'Aachman kabir(1001)',
      note: '',
    },
  ],
  totalTimelineTitle: 'Showing result from 1st Dec 2022 to 31th Dec 2022',
  handleTotalTimelineSearch: () => {},
  totalTimelineFilter: [
    { id: 1, label: 'Add New', onClick: () => {} },
    { id: 2, label: 'Bulk Upload', onClick: () => {} },
    { id: 3, label: 'Send ESS invite', onClick: () => {} },
    { id: 4, label: 'Download', onClick: () => {} },
  ],
  totalTimelineStartDateChange: () => {},
  totalTimelineEndDateChange: () => {},
  totalTimelineOnFetch: () => {},
};

TotalTimeline.propTypes = {
  totalTimeline: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      time: PropTypes.string,
      title: PropTypes.string,
      desc: PropTypes.string,
      note: PropTypes.string,
    }),
  ),
  totalTimelineTitle: PropTypes.string,
  handleTotalTimelineSearch: PropTypes.func,
  totalTimelineFilter: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
  }),
  totalTimelineStartDateChange: PropTypes.func,
  totalTimelineEndDateChange: PropTypes.func,
  totalTimelineOnFetch: PropTypes.func,
};

export default TotalTimeline;
